import { useLocation, useNavigate } from "react-router-dom";
import {
  exhibitionFilterStore,
  useExhibitionFilters,
} from "../useExhibitionFilters";
import { useLazyQuery } from "@apollo/client";
import { FETCH_EXHIBITIONS_LIST as fetchExhibitionsListQuery } from "../../../../graphql/query/Exhibition";
import { Button } from "../../../../components/ui";
import { GridInputs, SearchForm } from "../../../../components/Functional";
import exhibitionTypeOptions from "../../exhibitionTypeOptions";
import { buildNavigationUrl } from "../../../../util/buildNavigationUrl";

const ExhibitionSearch = props => {
  const { closeModal, onSearchSubmitted } = props || {};
  const navigate = useNavigate();
  const location = useLocation();
  const { formik } = useExhibitionFilters();
  const input = exhibitionFilterStore.get();
  const [fetchExhibitionsV2, { loading }] = useLazyQuery(
    fetchExhibitionsListQuery,
  );

  const monthOptions = [
    { value: 1, label: "January" },
    { value: 2, label: "Feburary" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const inputs = {
    className:
      "items-top mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3",
    inputs: [
      {
        label: "Exhibition Title",
        name: "title",
        type: "text",
      },
      {
        label: "Contact",
        name: "contactId",
        type: "contactSearch",
      },
      {
        hasOperator: true,
        isMulti: true,
        label: "Type",
        name: "type",
        type: "multi-select",
        options: exhibitionTypeOptions,
      },
      {
        label: "Start Day",
        name: "startDay",
        type: "number",
        min: 1,
        max: 31,
        allowEmpty: true,
      },
      {
        label: "Start Month",
        name: "startMonth",
        type: "multi-select",
        options: monthOptions,
      },
      {
        label: "Start Year",
        name: "startYear",
        type: "number",
        min: 1900,
        max: 2099,
        allowEmpty: true,
      },
      {
        label: "End Day",
        name: "endDay",
        type: "number",
        min: 1,
        max: 31,
        allowEmpty: true,
      },
      {
        label: "End Month",
        name: "endMonth",
        type: "multi-select",
        options: monthOptions,
      },
      {
        label: "End Year",
        name: "endYear",
        type: "number",
        min: 1900,
        max: 2099,
        allowEmpty: true,
      },
      {
        label: "Sage Code",
        name: "sageCode",
        type: "text",
      },
      {
        label: "ID",
        name: "id",
        type: "text",
      },
      {
        label: "Presentation",
        name: "channelPresentation",
        type: "multi-select",
        options: [
          { label: "Private", value: 0 },
          { label: "Public", value: 1 },
        ],
        isNullable: false,
      },
    ],
  };

  const inputProps = {
    formik,
    ...inputs,
  };

  const handleSubmit = e => {
    e?.preventDefault();
    const currentParams = new URLSearchParams(location.search);
    const nextParams = new URLSearchParams();
    ["listId", "imageListId", "workingListId", "imageWorkingListId"].forEach(
      key => {
        const value = currentParams.get(key);
        if (value) {
          nextParams.set(key, value);
        }
      },
    );

    fetchExhibitionsV2({ variables: { input } }).then(() => {
      navigate(buildNavigationUrl("/exhibition", nextParams));
      // Performing a new search invalidates any selection from the previous
      // result set; clear it so stale ids cannot reach bulk actions.
      onSearchSubmitted?.();
      closeModal();
    });
  };

  const searchButtonProps = {
    action: "black",
    label: loading ? "Searching" : "Search",
    disabled: loading,
    type: "submit",
  };

  const resetButtonProps = {
    action: "default",
    label: "Reset",
    onClick: formik?.resetForm,
  };

  return (
    <SearchForm onSubmit={handleSubmit}>
      <div>
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <div className="text-xl font-bold">Exhibition Search</div>
          <div className="flex w-full flex-wrap gap-2 sm:w-auto sm:gap-4">
            <Button {...resetButtonProps} />
            <Button {...searchButtonProps} />
          </div>
        </div>
        <div>
          <GridInputs {...inputProps} />
        </div>
      </div>
    </SearchForm>
  );
};

export default ExhibitionSearch;
